
import { FloatingFeature } from "@models";
import { Sense } from "@dndModels/constantized/Sense";

export class SenseFeature extends FloatingFeature {
  sense_id = "";
  range = 0;
  or_add = 0;

  sense: Sense | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.sense_id = obj.sense_id ? obj.sense_id : "";
      this.range = obj.range ? obj.range : 0;
      this.or_add = obj.or_add ? obj.or_add : 0;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.sense_id = obj.sense_id ? obj.sense_id : "";
  //     this.range = obj.range ? obj.range : 0;
  //     this.or_add = obj.or_add ? obj.or_add : 0;
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      sense_id: this.sense_id,
      range: this.range,
      or_add: this.or_add
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SenseFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: SenseFeature) {
    this.sense_id = copyMe.sense_id;
    this.range = copyMe.range;
    this.or_add = copyMe.or_add;
  }

  clone(drop_ids = false): SenseFeature {
    const new_obj = new SenseFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copySense(copyMe: Sense): void {
    this.sense_id = copyMe._id;
    this.sense = copyMe;
  }
}